<template>
  <el-dialog :title="`模板详情(${clibInfo.vacFieldLibName})`"
    :visible.sync="visible"
    width="500px"
    @closed='handleClosed'
    :close-on-press-escape="false">
    <el-form label-width="80px"
      :model="clibInfo"
      :rules="rule1"
      ref="ruleForm"
      v-if="clibInfo.fieldCode === 'wxPublicAccount'">
      <el-form-item label="公众号:"
        prop="wxAccount">
        <el-input v-model="clibInfo.wxAccount"></el-input>
      </el-form-item>
      <el-form-item label="二维码:"
        prop="accountQRCodeImage">
        <upload-image v-model="clibInfo.accountQRCodeImage"
          :limit="1" />
      </el-form-item>
    </el-form>
    <el-form label-width="80px"
      :model="clibInfo"
      :rules="rule1"
      ref="ruleForm"
      v-else>
      <el-form-item label="导航名:"
        prop="fieldName">
        <el-input v-model="clibInfo.fieldName"></el-input>
      </el-form-item>
      <el-form-item label="图文:"
        prop="fieldList">
        <desc-images :edit="true"
          v-model="clibInfo.fieldList" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="toggleModal(false)"
        :loading="loading">取 消</el-button>
      <el-button type="primary"
        @click="handleSubmit"
        :loading="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import UploadImage from '@/components/public/upload-image-new.vue'
import DescImages from '@/components/public/desc-images.vue'
export default {
  name: 'clib-detail-modal',
  components: { UploadImage, DescImages },
  props: {
    fecth: {
      type: Function
    }
  },
  data () {
    return {
      loading: false,
      visible: false,
      clibInfo: {},
      rule1: {
        wxAccount: [
          { required: true, message: '请输入公众号名称', trigger: 'blur' }
        ],
        accountQRCodeImage: [
          { required: true, message: '请上传公众号二维码', trigger: 'blur' }
        ],
        fieldName: [
          { required: true, message: '请输入导航名称', trigger: 'blur' }
        ],
        fieldList: [
          { required: true, message: '请上传图文', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    toggleModal (visible) {
      this.visible = visible
    },
    handleClosed () {
      this.$nextTick(() => {
        this.clibInfo = {}
      })
    },
    getvaclib (vacFieldLibId, vendorId) {
      this.loading = true
      this.$store.dispatch('vas/getvaclib', {
        payload: {
          vendorId,
          vacFieldLibId
        },
        success: (res) => {
          this.loading = false
          res.data.fieldValue = JSON.parse(res.data.fieldValue)
          if (res.data.fieldCode === 'wxPublicAccount') {
            this.clibInfo = {
              vendorId: res.data.vendorId,
              vacId: res.data.vacId,
              vacFieldLibId: res.data.vacFieldLibId,
              vacFieldLibName: res.data.vacFieldLibName,
              fieldCode: res.data.fieldCode,
              wxAccount: res.data.fieldValue.account,
              accountQRCodeImage: res.data.fieldValue.accountQRCodeImage ? res.data.fieldValue.accountQRCodeImage.split(',').map(item => ({
                url: item
              })) : []
            }
          } else {
            this.clibInfo = {
              vendorId: res.data.vendorId,
              vacId: res.data.vacId,
              vacFieldLibId: res.data.vacFieldLibId,
              vacFieldLibName: res.data.vacFieldLibName,
              fieldCode: res.data.fieldCode,
              fieldName: res.data.fieldName,
              fieldList: res.data.fieldValue.multiMedias.map(item => ({ id: item.id, name: item.name, mediaType: item.mediaType, url: item.content }))
            }
          }
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleSubmit () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          let { vendorId, vacId, vacFieldLibId, vacFieldLibName, fieldCode, fieldName } = this.clibInfo
          let fieldValue = {}
          if (fieldCode === 'wxPublicAccount') {
            fieldValue = JSON.stringify({ 'account': this.clibInfo.wxAccount, 'accountQRCodeImage': this.clibInfo.accountQRCodeImage.map(item => item.url).join(','), 'accountDesc': '' })
          } else {
            fieldValue = JSON.stringify({ 'multiMedias': this.clibInfo.fieldList.map(item => ({ 'id': item.id, 'name': item.name, 'mediaType': item.mediaType, 'content': item.url })) })
          }
          this.$store.dispatch('vas/updatevaclib', {
            payload: {
              vendorId,
              vacId,
              vacFieldLibId,
              vacFieldLibName,
              fieldCode,
              fieldName,
              fieldValue
            },
            success: (res) => {
              this.loading = false
              this.toggleModal(false)
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped></style>
